/**
 * TSS app entry module.
 *
 * Bridges Dawn's pubsub events (emitted by the retained Dawn cart/variant JS)
 * into our custom event bus so rebuilt UI listens on a single channel
 * (`document.addEventListener(ThemeEvents.cartUpdate, ...)`).
 *
 * Dawn's `subscribe` is a global from pubsub.js (classic script). Dawn's
 * PUB_SUB_EVENTS string values are stable, so we reference them directly.
 */
import { ThemeEvents, CartUpdateEvent, CartErrorEvent } from '@theme/events';
import { initFlyToCart } from '@theme/fly-to-cart';
import { initVariantCartState } from '@theme/variant-cart-state';
import { initShippingBar } from '@theme/shipping-bar';
import { initAnalytics } from '@theme/analytics';

const DAWN_EVENTS = {
  cartUpdate: 'cart-update',
  cartError: 'cart-error',
  variantChange: 'variant-change'
};

function bridgeDawnEvents() {
  if (typeof window.subscribe !== 'function') return;

  window.subscribe(DAWN_EVENTS.cartUpdate, (payload) => {
    document.dispatchEvent(
      new CartUpdateEvent(payload?.cartData ?? null, payload?.source ?? 'dawn', {
        source: payload?.source,
        sections: payload?.cartData?.sections
      })
    );
  });

  window.subscribe(DAWN_EVENTS.cartError, (payload) => {
    document.dispatchEvent(new CartErrorEvent(payload?.source ?? 'dawn', payload?.message ?? ''));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bridgeDawnEvents, { once: true });
} else {
  bridgeDawnEvents();
}

initFlyToCart();
initVariantCartState();
initShippingBar();
initAnalytics();

export { ThemeEvents };
